<div class="row login-form">
  <div class="login-image col-md-5">
  </div>
  <div class="col-md-7">
    <form class="d-flex justify-content-center mx-auto mb-2" (ngSubmit)="login()">
      <div class="card" title="Client Login">
        <div class="card-body">
          <div class="card-title">
            <div class="d-flex justify-content-center">
              <img id="login-logo" style="text-align: center" src="/app/assets/images/ms-client-sm.png" alt="Milestone Client Logo" />
            </div>
            <h3 class="d-flex justify-content-center">Client Login</h3>
          </div>
        </div>
        <spk-text [isFocused]="true" [name]="'Username'" [(model)]="formModel.Username" [maxlength]="100"></spk-text>
        <spk-password [name]="'Password'" [maxlength]="100" [(model)]="formModel.Password"></spk-password>

        <div class="d-flex justify-content-between align-items-end">
          <div></div>
          <button class="btn btn-primary login-button" type="submit">Login</button>
        </div>
        <!--
        <div class="request-access">
          New to MS Client?
          <a class="request-account" routerLink="/request-account">Request an Account</a>
        </div>
        -->
      </div>

    </form>
  </div>
</div>
